// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-home[data-v-4c626606]{display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;height:100%;width:1500px}.category-main[data-v-4c626606]{width:1250px;margin-left:250px}.category-aside[data-v-4c626606]{width:250px;overflow-x:hidden;overflow-y:auto;position:fixed;top:80px;bottom:0}", ""]);
// Exports
module.exports = exports;
